import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import { ApplicationResponse } from "@src/common/domain/common.model"
import { NewProductModelRef, ProductStore } from "../domain/product.model"

export const addProductList = createAsyncThunk<void, any>("product/addProduct",
 async (payload: any) => {

    const response = await api.post<ApplicationResponse<NewProductModelRef[]>>(`${AppConstants.api}/product/create`, payload)
})
export const updateProductList = createAsyncThunk<void, any>("product/updateProduct",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<NewProductModelRef[]>>(`${AppConstants.api}/product/update`, payload)
})
export const fetchProductList = createAsyncThunk<any[], void> ("product/fetchProduct",
    async () => {
        const response = await api.get<ApplicationResponse<NewProductModelRef[]>>(`${AppConstants.api}/product/list`)
        return response.data.data || []   
    })
   export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/product/delete?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
const ProductSlice = createSlice({
    name: "product",
    initialState: {minimal: {status: "loading", error: null, data: []}} as ProductStore,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchProductList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchProductList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })

    }
})

export default ProductSlice.reducer
